<template>
    <div class="interactive">
        <div class="active-div">
            <div class="active-video">
                <div class="video-left">
                    <div class="video-title">
                        <img class="title-logo" :src="liveInfo.picUrl" alt="" />
                        <div class="title-info">
                            <p class="info-text">{{ videoData.title }}</p>
                            <div class="info-name">
                                <div class="names">{{ videoData.userName }}</div>
                                <div class="name-box">
                                    <!-- <div class="name-one">
                                        <img src="../assets/active-share.png" alt="" />
                                        <span>分享</span>
                                    </div> -->
                                    <div class="name-two">关注</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="video-box">
                        <video-player class="video-player vjs-custom-skin" v-if="videoOptions.sources[0].src"
                            ref="videoPlayer" :options="videoOptions"></video-player>
                    </div>
                </div>
                <div class="video-right">
                    <div class="right-one">
                        <div>
                            <img src="../assets/active-game.png" alt="" />
                            <p>如何参与游玩？</p>
                        </div>
                    </div>
                    <div class="right-two">
                        <div class="first-step">
                            <p>01.扫码下载APP</p>
                            <div class="code">
                                <img src="https://static.cd.zhangkongyl.cn:901/headimg/20250305152722_1588f091-5ed4-475b-a8ad-abf72b33980c.png"
                                    alt="">
                            </div>
                        </div>
                        <div class="second-step">
                            <p>02.进入对应房间<br />进行游玩</p>
                            <img src="../assets/active-app.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="more-div">
            <div class="more-title">
                <img src="../assets/zuixin.png" alt="" />
                <span>更多推荐</span>
            </div>
            <div class="list-div">
                <div class="list-box" v-for="item in recommendData" :key="item.id" @click="changeVideo(item.id)">
                    <div class="box-img">
                        <img class="img-bg" :src="item.picUrl" alt="" />
                        <div class="img-time">
                            <img src="../assets/hu-time.png" alt="" />
                            <span>{{ item.playTime }}</span>
                        </div>
                    </div>
                    <div class="list-title">
                        <div class="title-info">{{ item.title }}</div>
                        <div class="title-text">
                            <div class="text-name">
                                <img src="../assets/hu-user.png" alt="" />
                                <span>{{ item.userName }}</span>
                            </div>
                            <div class="text-name">
                                <img src="../assets/hu-video.png" alt="" />
                                <span>{{
                                    item.num > 10000
                                        ? Math.floor(
                                            item.num / 10000
                                        ) + "万"
                                        : item.num
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { recommendListApi, interactionApi, homeDailyApi } from "../api/api.js";
export default {
    name: "Interactive",
    data() {
        return {
            liveInfo: {},
            videoData: {},
            recommendData: [],
            videoOptions: {
                // video.js的配置选项
                controls: true,
                autoplay: true,
                muted: true,
                loop: true,
                width: "100%", // 可以设置为具体的像素值或百分比
                // height: "100%", // 同上
                sources: [
                    {
                        src: '', // 替换为你的视频源
                        type: "video/mp4",
                    },
                ],
                controlBar: {
                    volumeControl: true,
                    remainingTimeDisplay: false,
                },
                notSupportedMessage: "此视频暂无法播放，请稍后再试",
            },
        };
    },
    components: {},
    mounted() {
        this.recommendList()
        if (this.$route.query.id) {
            this.interactionId(this.$route.query.id)
        } else {
            this.homeDaily()
        }

    },
    methods: {
        async homeDaily() {
            const res = await homeDailyApi();
            this.interactionId(res.data.data[0].id)
        },
        async interactionId(id) {
            const res = await interactionApi(id)
            this.liveInfo = res.data.data.liveInfo
            this.videoData = res.data.data.one
            this.videoOptions.sources[0].src =
                res.data.data.one.videoUrl;
        },

        async recommendList() {
            const res = await recommendListApi({
                pageindex: 1,
                pagesize: 5,
            });
            this.recommendData = res.data.data.records;
        },
        changeVideo(id) {
            // this.interactionId(id)
            this.$router.push({
                path: "/interactive",
                query: {
                    id,
                }
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.interactive {
    width: 100vw;
    height: 1403px;
    background: url("../assets/active-bg.png");
    background-position: center;
    background-size: cover;
}

.active-div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 50px;

    .active-video {
        width: 70%;
        height: 774px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .video-left {
            width: 83%;
            height: 100%;
            border-radius: 5px;

            .video-title {
                height: 15%;
                display: flex;
                align-items: center;
                background: #fff;

                .title-logo {
                    width: 84px;
                    height: 84px;
                    border-radius: 42px;
                    margin-left: 20px;
                }

                .title-info {
                    width: 100%;
                    padding-left: 20px;

                    .info-text {
                        color: #000;
                        font-weight: bold;
                        font-size: 22px;
                    }

                    .info-name {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .names {
                            color: #6f6f6f;
                            font-size: 18px;
                        }

                        .name-box {
                            display: flex;
                            align-items: center;
                            margin-right: 20px;
                            cursor: pointer;

                            .name-one {
                                display: flex;
                                align-items: center;
                                margin-right: 20px;

                                img {
                                    width: 23px;
                                    height: 23px;
                                    padding-right: 10px;
                                }
                            }

                            .name-two {
                                width: 100px;
                                height: 40px;
                                background: #ff9000;
                                border-radius: 20px;
                                color: #fff;
                                font-size: 18px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                }
            }

            .video-box {
                width: 100%;
                height: 85%;

                .video-player {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .video-right {
            width: 15%;
            height: 100%;
            border-radius: 5px;

            .right-one {
                height: 15%;
                background: #ff9000;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;

                img {
                    width: 47px;
                    height: 35px;
                }

                p {
                    color: #fff;
                    font-size: 18px;
                    padding-top: 10px;
                    font-weight: bold;
                }
            }

            .right-two {
                height: 85%;
                background: #fff;
                text-align: center;

                .first-step {
                    padding: 50px 0;

                    p {
                        color: #6f6f6f;
                        font-size: 20px;
                        padding-bottom: 15px;
                    }

                    .code {
                        width: 125px;
                        height: 125px;
                        margin: 0 auto;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .second-step {
                    p {
                        color: #6f6f6f;
                        font-size: 20px;
                        padding-bottom: 15px;
                    }
                }
            }
        }
    }
}

.more-div {
    width: 70%;
    margin: 0 auto;
    margin-top: 110px;

    .more-title {
        display: flex;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid #6d6d6d;
        padding-bottom: 10px;

        span {
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            padding-left: 10px;
        }
    }

    .list-div {
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 30px;

        .list-box {
            width: 185px;
            margin: 0 25px;

            .box-img {
                width: 100%;
                height: 250px;
                position: relative;

                .img-bg {
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                }

                .img-time {
                    position: absolute;
                    bottom: 2%;
                    right: 7%;
                    display: flex;
                    align-items: center;

                    span {
                        font-size: 14px;
                        color: #fff;
                        padding-left: 5px;
                    }
                }
            }
        }

        .list-title {
            .title-info {
                color: #fff;
                font-size: 16px;
                padding: 10px 0;
                white-space: nowrap;
                /* 不换行 */
                overflow: hidden;
                /* 隐藏超出的内容 */
                text-overflow: ellipsis;
                /* 用省略号表示被隐藏的部分 */
                max-width: 100%;
                /* 设置最大宽度以限制文本的显示长度 */
            }

            .title-text {
                font-size: 14px;
                color: #838383;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .text-name {
                    display: flex;
                    align-items: center;

                    img {
                        width: 12px;
                        height: 12px;
                        padding-right: 5px;
                    }
                }
            }
        }
    }
}

::v-deep .video-js {
    height: 100%;
}

/*播放按钮设置成宽高一致，圆形，居中*/
::v-deep .vjs-custom-skin>.video-js .vjs-big-play-button {
    outline: none;
    border: none;
    width: 66px;
    height: 66px !important;
    background-color: rgba(0, 0, 0, 0) !important;
}

::v-deep .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    content: '';
    width: 66px;
    height: 66px;
    background: url('../assets/play.png') no-repeat;
    background-size: 100% 100%;
}

::v-deep .vjs-custom-skin>.video-js .vjs-play-progress:before {
    top: 0;
}
</style>
